import { Typography } from "@mui/material";
import React from "react";

const RequiredField = ({ message = "Ce champ est obligatoire"}) => (
  <Typography variant="caption" display="block" color="error">
    {message}
  </Typography>
);

export default RequiredField